import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import * as CurrencyFormat from 'react-currency-format';
import { Table } from 'react-bootstrap';

class FundTransactions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            transactionsArray: []
        }
    }

    static getDerivedStateFromProps(props, state) {
        let transactionsArray = [];
        props.transactions && props.transactions.map(transaction => transactionsArray.push(transaction));

        return {
            transactionsArray: transactionsArray
        }
    }

    render() {
        const { t } = this.props
        return (
            <div
            // style={{marginLeft: "12px"}}
            >{
                this.props.isTransactionsEmpty ? <div className="tabMessage">There are no transactions for chosen period</div> :    
                !this.state.transactionsArray || this.state.transactionsArray.length === 0 ? <div className="tabMessage">{t('fetching') + " " + t('transaction')}s</div> :
                        // this.state.transactionsArray.length === 0 ? <div className="tabMessage">{t('no') + " " + t('transaction')}s</div> :
                            <Table responsive id="FundDetailsTab" style={{ marginLeft: "-1px", marginRight: "1px" }}
                                className="table-responsive superlifeLegacyPlan transactions">
                                <thead>
                                    <th style={{ height: 20 }}>{t('transactions:date')}</th>
                                    <th style={{ height: 20 }}>{t('transactions:account')}</th>
                                    <th style={{ height: 20 }}>{t('transactions:transactionDetails')}</th>
                                    <th style={{ height: 20 }}>{t('transactions:fund')}</th>
                                    <th style={{ height: 20 }}>{t('transactions:debits')}</th>
                                    <th style={{ height: 20 }}>{t('transactions:credits')}</th>
                                    <th style={{ height: 20 }}>{t('transactions:balance')}</th>
                                </thead>
                                <tbody>
                                    {
                                        this.state.transactionsArray.map(transaction =>
                                            !transaction.accounts ? "" : transaction.accounts.map((account, accountIndex) =>
                                                !account.details ? "" : account.details.map((detail, detailIndex) =>
                                                    !detail.funds ? "" : detail.funds.map((fund, fundIndex) =>

                                                        <tr style={{ lineHeight: 1 }} key={fundIndex}>
                                                            <td style={{
                                                                fontWeight:
                                                                    transaction.transactionType === "opening" || transaction.transactionType === "closing" ?
                                                                        "bold" : "normal"
                                                            }}>{accountIndex === 0 && detailIndex === 0 && fundIndex === 0 ? transaction.date : ""}</td>
                                                            <td style={{
                                                                fontWeight:
                                                                    transaction.transactionType === "opening" || transaction.transactionType === "closing" ?
                                                                        "bold" : "normal"
                                                            }}>{detailIndex === 0 && fundIndex === 0 ? account.description : ""}</td>
                                                            <td style={{
                                                                fontWeight:
                                                                    transaction.transactionType === "opening" || transaction.transactionType === "closing" ?
                                                                        "bold" : "normal"
                                                            }}>{fundIndex === 0 ? detail.description : ""}</td>
                                                            <td style={{
                                                                fontWeight:
                                                                    transaction.transactionType === "opening" || transaction.transactionType === "closing" ?
                                                                        "bold" : "normal"
                                                            }}>{fund.description}</td>
                                                            <td style={{
                                                                textAlign: "right", fontWeight:
                                                                    transaction.transactionType === "opening" || transaction.transactionType === "closing" ?
                                                                        "bold" : "normal"
                                                            }}>{fund.debits ? fund.debits !== null ?
                                                                <CurrencyFormat value={Number(fund.debits).toFixed(2)}
                                                                    displayType={'text'}
                                                                    thousandSeparator={true}
                                                                    prefix={'$'} /> : "" : ""}</td>
                                                            <td style={{
                                                                textAlign: "right", fontWeight:
                                                                    transaction.transactionType === "opening" || transaction.transactionType === "closing" ?
                                                                        "bold" : "normal"
                                                            }}>{fund.credits ? fund.credits !== null ?
                                                                <CurrencyFormat value={Number(fund.credits).toFixed(2)}
                                                                    displayType={'text'}
                                                                    thousandSeparator={true}
                                                                    prefix={'$'} /> : "" : ""}</td>
                                                            <td style={{
                                                                textAlign: "right", fontWeight:
                                                                    transaction.transactionType === "opening" || transaction.transactionType === "closing" ?
                                                                        "bold" : "normal"
                                                            }}>{fund.balance ? fund.balance !== null ?
                                                                <CurrencyFormat value={Number(fund.balance).toFixed(2)}
                                                                    displayType={'text'}
                                                                    thousandSeparator={true}
                                                                    prefix={'$'} /> : "" : ""}</td>
                                                        </tr>))))
                                    }
                                </tbody>
                            </Table>
                }
            </div>
        )
    }
}

export default withTranslation()(FundTransactions);